import { useState } from "react";
import { X, ZoomIn } from "lucide-react";

const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/scoeiv8c_WhatsApp%20Image%202026-06-03%20at%2019.13.51-3.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/rv22gxec_WhatsApp%20Image%202026-06-03%20at%2019.15.27.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/0n2sjxf5_WhatsApp%20Image%202026-06-03%20at%2019.13.51-2.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/808z5e5v_WhatsApp%20Image%202026-06-03%20at%2019.13.52.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/n8cpq1l3_WhatsApp%20Image%202026-06-03%20at%2019.13.51-4.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/1b207eqr_WhatsApp%20Image%202026-06-04%20at%2011.00.23.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/hge218ao_WhatsApp%20Image%202026-06-04%20at%2011.01.49.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/vdcwix7b_WhatsApp%20Image%202026-06-05%20at%2013.11.06.jpeg",
  },
];

export const Gallery = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
              Galeria de Trabalhos
            </span>
          </div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
            Atuação clínica e{" "}
            <span className="italic text-[#D4AF37]">pericial</span> em imagens.
          </h2>
          <p className="mt-6 text-white/65 max-w-2xl leading-relaxed">
            Uma seleção de trabalhos realizados — da endodontia e ortodontia
            à análise antropológica forense.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
          {GALLERY.map((item, i) => (
            <button
              key={i}
              onClick={() => setLightbox(item)}
              data-testid={`gallery-item-${i}`}
              className="group relative overflow-hidden border border-[#D4AF37]/15 hover:border-[#D4AF37]/60 transition-all duration-500 aspect-square"
            >
              <img
                src={item.src}
                alt=""
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              {/* Zoom icon on hover */}
              <div className="absolute inset-0 bg-[#050505]/0 group-hover:bg-[#050505]/30 transition-colors flex items-center justify-center">
                <div className="w-12 h-12 border border-[#D4AF37] bg-[#050505]/60 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <ZoomIn size={18} className="text-[#D4AF37]" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setLightbox(null)}
          className="fixed inset-0 z-[100] bg-[#050505]/95 backdrop-blur-md flex items-center justify-center p-4 sm:p-12 cursor-zoom-out"
        >
          <button
            onClick={() => setLightbox(null)}
            data-testid="lightbox-close"
            aria-label="Fechar"
            className="absolute top-6 right-6 w-12 h-12 border border-[#D4AF37]/40 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 flex items-center justify-center transition-colors"
          >
            <X size={20} className="text-[#D4AF37]" />
          </button>

          <img
            src={lightbox.src}
            alt=""
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] max-w-[90vw] w-auto border border-[#D4AF37]/30 cursor-default"
          />
        </div>
      )}
    </section>
  );
};
